import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ROUTES } from '../../constants/routes';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationComponent {
  public user$ = this.authService.user$;

  PUBLIC_ITEMS = [
    {
      title: 'home',
      path: '',
    },
    {
      title: 'contact_us',
      path: ROUTES.CONTACT_US,
    },
  ];

  get navigationItems(): any {
    const items = [...this.PUBLIC_ITEMS];

    return items;
  }

  constructor(public authService: AuthService) {}
}
